import { IInventoryPage } from '../../inventory-page.interface';


export const USER_FORGOT_PASSWORD_PAGE: IInventoryPage = {
	'route': '/user/forgot-password',
	'title': 'Forgot Password',
	'uiReference': [
		'Reset your password',
		'Verify your email, then choose a new password for your Flying account.',
		'Enter email',
		'Enter code',
		'Create a new password',
		'Repeat the new password',
		'Password updated',
		'Your password was reset successfully. You can now sign in with your new password.',
		'Go to sign in',
		'Email',
		'Please enter a valid email.',
		'Send verification code',
		'Remember your password? Sign in',
		'Verification code',
		'Resend s',
		'Please enter the verification code.',
		'New password',
		'Use at least 8 characters with uppercase and lowercase letters.',
		'Confirm password',
		'The passwords do not match.',
		'Set new password',
		'Flying account sign in',
		'Appearance',
		'One secure account for Flying Research and Flying Upload'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/public/auth/auth-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/public/auth/forgot-password/forgot-password.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/public/auth/forgot-password/forgot-password.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/public/auth/auth-shell/auth-shell.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/public/auth/auth-shell/auth-shell.component.html'
	]
};
